import React, { useState } from 'react';
import './Services.css';

const services = [
  {
    icon: 'bi-moisture',
    title: 'Dehumidifier HVAC Systems',
    desc: 'Expert servicing and maintenance for all types of Dehumidifier HVAC systems ensuring optimal year-round performance.',
    tags: ['Servicing', 'Maintenance', 'All Makes'],
  },
  {
    icon: 'bi-wind',
    title: 'Air Handling Units (AHU)',
    desc: 'Comprehensive AHU servicing with all ranges of desiccant rotors and motor types, tuned for peak efficiency.',
    tags: ['AHU', 'Desiccant Rotors', 'Motors'],
  },
  {
    icon: 'bi-gear-wide-connected',
    title: 'Compressed Air Dryers',
    desc: 'Servicing of desiccant and refrigeration type compressed air dryers with high precision and care.',
    tags: ['Desiccant Type', 'Refrigeration Type'],
  },
  {
    icon: 'bi-box-seam',
    title: 'Mould Dehumidification',
    desc: 'Specialised mould dehumidification systems, plastic auxiliary equipment including auto loaders and high heat plastic dryers.',
    tags: ['Auto Loader', 'Plastic Dryers', 'Auxiliary'],
  },
  {
    icon: 'bi-snow',
    title: 'Outdoor Unit (ODU) Servicing',
    desc: 'Outdoor unit servicing with thorough diagnostics, precision tuning and high-quality workmanship standards.',
    tags: ['ODU', 'Diagnostics', 'Tuning'],
  },
  {
    icon: 'bi-layout-wtf',
    title: 'Duct Installation & Fabrication',
    desc: 'Duct installation and custom fabrication work executed to the highest standards of quality and efficiency.',
    tags: ['Installation', 'Fabrication', 'Custom'],
  },
];

function Services() {
  const [hovered, setHovered] = useState(null);

  return (
    <section className="services-section" id="services">
      <div className="container">
        <div className="text-center mb-5">
          <div className="section-eyebrow">What We Do</div>
          <h2 className="section-title">Our Services</h2>
          <p className="section-sub mx-auto" style={{ maxWidth: '560px' }}>
            Retrofit works, maintenance, installation and fabrication —
            a full spectrum of climate control services, all under one roof.
          </p>
        </div>

        <div className="row g-4">
          {services.map((s, i) => (
            <div className="col-md-6 col-lg-4" key={i}>
              <div
                className={`service-card ${hovered === i ? 'service-card--hovered' : ''}`}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
              >
                <div className="service-card-top-bar" />
                <div className="service-icon-wrap">
                  <i className={`bi ${s.icon}`}></i>
                </div>
                <h4 className="service-title">{s.title}</h4>
                <p className="service-desc">{s.desc}</p>
                <div className="service-tags">
                  {s.tags.map(t => (
                    <span key={t} className="service-tag">{t}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
